import React, { useState, useEffect } from 'react';
import { 
  Box, 
  Typography, 
  Paper, 
  Grid, 
  Card, 
  CardContent, 
  Button,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Switch,
  FormControlLabel,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Chip,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Checkbox,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Tabs,
  Tab,
  Divider,
  Alert,
  Snackbar,
  Tooltip,
  Badge
} from '@mui/material';
import { 
  Add as AddIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  ExpandMore as ExpandMoreIcon,
  Security as SecurityIcon,
  Person as PersonIcon,
  Group as GroupIcon,
  Visibility as VisibilityIcon,
  Create as CreateIcon,
  Edit as EditIcon2,
  Delete as DeleteIcon2,
  GetApp as ExportIcon,
  Publish as ImportIcon,
  Discount as DiscountIcon,
  Settings as SettingsIcon,
  Assignment as AssignmentIcon,
  CheckCircle as CheckCircleIcon,
  Warning as WarningIcon
} from '@mui/icons-material';
import { useCompany } from '../context/CompanyContext';

// Tab Panel Component
function TabPanel({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

const UserPermissions = () => {
  const { users } = useCompany();
  const [activeTab, setActiveTab] = useState(0);
  const [roles, setRoles] = useState([]);
  const [pagePermissions, setPagePermissions] = useState([]);
  const [operationPermissions, setOperationPermissions] = useState([]);
  const [discountPermissions, setDiscountPermissions] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [openDiscountDialog, setOpenDiscountDialog] = useState(false);
  const [selectedRole, setSelectedRole] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);
  const [formData, setFormData] = useState({});
  const [discountFormData, setDiscountFormData] = useState({});
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

  // Predefined page permissions
  const predefinedPages = [
    { id: 1, name: 'Dashboard', path: '/dashboard', module: 'Ana Sayfa', description: 'Ana sayfa görüntüleme' },
    { id: 2, name: 'Kullanıcı Yönetimi', path: '/users', module: 'Sistem', description: 'Kullanıcı ekleme/düzenleme' },
    { id: 3, name: 'Rol Yönetimi', path: '/roles', module: 'Sistem', description: 'Rol yönetimi' },
    { id: 4, name: 'Ürün Yönetimi', path: '/products', module: 'Stok', description: 'Ürün işlemleri' },
    { id: 5, name: 'Stok Yönetimi', path: '/stock', module: 'Stok', description: 'Stok işlemleri' },
    { id: 6, name: 'Satış Yönetimi', path: '/sales', module: 'Satış', description: 'Satış işlemleri' },
    { id: 7, name: 'Satın Alma', path: '/purchases', module: 'Satın Alma', description: 'Satın alma işlemleri' },
    { id: 8, name: 'Finans Yönetimi', path: '/finance', module: 'Finans', description: 'Finans işlemleri' },
    { id: 9, name: 'Raporlar', path: '/reports', module: 'Raporlar', description: 'Rapor görüntüleme' },
    { id: 10, name: 'Ayarlar', path: '/settings', module: 'Sistem', description: 'Sistem ayarları' }
  ];

  // Predefined operation permissions
  const predefinedOperations = [
    { id: 1, code: 'SALES_CREATE', name: 'Satış Oluştur', module: 'Satış', description: 'Yeni satış oluşturma' },
    { id: 2, code: 'SALES_EDIT', name: 'Satış Düzenle', module: 'Satış', description: 'Satış düzenleme' },
    { id: 3, code: 'SALES_DELETE', name: 'Satış Sil', module: 'Satış', description: 'Satış silme' },
    { id: 4, code: 'PURCHASE_CREATE', name: 'Satın Alma Oluştur', module: 'Satın Alma', description: 'Yeni satın alma oluşturma' },
    { id: 5, code: 'PURCHASE_APPROVE', name: 'Satın Alma Onayla', module: 'Satın Alma', description: 'Satın alma onaylama' },
    { id: 6, code: 'STOCK_ADJUST', name: 'Stok Düzenle', module: 'Stok', description: 'Stok düzenleme' },
    { id: 7, code: 'FINANCE_APPROVE', name: 'Finans Onayla', module: 'Finans', description: 'Finans onaylama' },
    { id: 8, code: 'USER_MANAGE', name: 'Kullanıcı Yönet', module: 'Sistem', description: 'Kullanıcı yönetimi' }
  ];

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      // Load roles
      const rolesResponse = await fetch('/api/advanced-user-management/roles');
      const rolesData = await rolesResponse.json();
      setRoles(rolesData);

      // Load page permissions
      const pageResponse = await fetch('/api/advanced-user-management/page-permissions');
      const pageData = await pageResponse.json();
      setPagePermissions(pageData);

      // Load operation permissions
      const operationResponse = await fetch('/api/advanced-user-management/operation-permissions');
      const operationData = await operationResponse.json();
      setOperationPermissions(operationData);

      // Load discount permissions
      const discountResponse = await fetch('/api/advanced-user-management/discount-permissions');
      const discountData = await discountResponse.json();
      setDiscountPermissions(discountData);
    } catch (error) {
      console.error('Error loading data:', error);
      showSnackbar('Veri yüklenirken hata oluştu', 'error');
    }
  };

  const showSnackbar = (message, severity = 'success') => {
    setSnackbar({ open: true, message, severity });
  };

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const handleAddRole = () => {
    setSelectedRole(null);
    setFormData({ 
      name: '', 
      description: '', 
      type: 'custom',
      pagePermissions: [],
      operationPermissions: []
    });
    setOpenDialog(true);
  };

  const handleEditRole = (role) => {
    setSelectedRole(role);
    setFormData(role);
    setOpenDialog(true);
  };

  const handleAddDiscountPermission = () => {
    setSelectedUser(null);
    setDiscountFormData({
      userId: '',
      maxDiscountRate: 0,
      maxDiscountAmount: 0,
      categoryRestrictions: [],
      brandRestrictions: [],
      requiresApproval: false,
      approvers: []
    });
    setOpenDiscountDialog(true);
  };

  const handleSaveRole = async () => {
    try {
      const url = selectedRole 
        ? `/api/advanced-user-management/roles/${selectedRole.id}`
        : '/api/advanced-user-management/roles';
      
      const method = selectedRole ? 'PUT' : 'POST';
      
      const response = await fetch(url, {
        method,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      });

      if (response.ok) {
        showSnackbar(selectedRole ? 'Rol güncellendi' : 'Rol oluşturuldu');
        setOpenDialog(false);
        loadData();
      } else {
        throw new Error('İşlem başarısız');
      }
    } catch (error) {
      showSnackbar('Rol kaydedilirken hata oluştu', 'error');
    }
  };

  const handleSaveDiscountPermission = async () => {
    try {
      const url = selectedUser 
        ? `/api/advanced-user-management/discount-permissions/${selectedUser.id}`
        : '/api/advanced-user-management/discount-permissions';
      
      const method = selectedUser ? 'PUT' : 'POST';
      
      const response = await fetch(url, {
        method,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(discountFormData)
      });

      if (response.ok) {
        showSnackbar(selectedUser ? 'İskonto izni güncellendi' : 'İskonto izni oluşturuldu');
        setOpenDiscountDialog(false);
        loadData();
      } else {
        throw new Error('İşlem başarısız');
      }
    } catch (error) {
      showSnackbar('İskonto izni kaydedilirken hata oluştu', 'error');
    }
  };

  const handleDeleteRole = async (roleId) => {
    if (window.confirm('Bu rolü silmek istediğinizden emin misiniz?')) {
      try {
        const response = await fetch(`/api/advanced-user-management/roles/${roleId}`, {
          method: 'DELETE'
        });

        if (response.ok) {
          showSnackbar('Rol silindi');
          loadData();
        } else {
          throw new Error('Silme işlemi başarısız');
        }
      } catch (error) {
        showSnackbar('Rol silinirken hata oluştu', 'error');
      }
    }
  };

  const handlePagePermissionChange = (pageId, action, checked) => {
    const newPagePermissions = [...(formData.pagePermissions || [])];
    const existingIndex = newPagePermissions.findIndex(p => p.pagePermissionId === pageId);
    
    if (existingIndex >= 0) {
      newPagePermissions[existingIndex] = {
        ...newPagePermissions[existingIndex],
        [action]: checked
      };
    } else {
      newPagePermissions.push({
        pagePermissionId: pageId,
        [action]: checked
      });
    }
    
    setFormData({ ...formData, pagePermissions: newPagePermissions });
  };

  const handleOperationPermissionChange = (operationId, checked, maxAmount = 0, minAmount = 0) => {
    const newOperationPermissions = [...(formData.operationPermissions || [])];
    const existingIndex = newOperationPermissions.findIndex(p => p.operationPermissionId === operationId);
    
    if (existingIndex >= 0) {
      if (checked) {
        newOperationPermissions[existingIndex] = {
          ...newOperationPermissions[existingIndex],
          canExecute: checked,
          maxAmount,
          minAmount
        };
      } else {
        newOperationPermissions.splice(existingIndex, 1);
      }
    } else if (checked) {
      newOperationPermissions.push({
        operationPermissionId: operationId,
        canExecute: checked,
        maxAmount,
        minAmount
      });
    }
    
    setFormData({ ...formData, operationPermissions: newOperationPermissions });
  };

  return (
    <Box sx={{ p: 3 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Typography variant="h4" gutterBottom>
          <SecurityIcon sx={{ mr: 1, verticalAlign: 'middle' }} />
          Gelişmiş Kullanıcı Yönetimi
        </Typography>
        <Box>
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={handleAddRole}
            sx={{ mr: 1 }}
          >
            Yeni Rol
          </Button>
          <Button
            variant="outlined"
            startIcon={<DiscountIcon />}
            onClick={handleAddDiscountPermission}
          >
            İskonto İzni
          </Button>
        </Box>
      </Box>

      <Paper sx={{ width: '100%' }}>
        <Tabs value={activeTab} onChange={handleTabChange} aria-label="user management tabs">
          <Tab label="Roller" icon={<GroupIcon />} />
          <Tab label="Sayfa İzinleri" icon={<VisibilityIcon />} />
          <Tab label="İşlem İzinleri" icon={<SettingsIcon />} />
          <Tab label="İskonto İzinleri" icon={<DiscountIcon />} />
          <Tab label="Kullanıcı Özeti" icon={<PersonIcon />} />
        </Tabs>

        <TabPanel value={activeTab} index={0}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Rol Adı</TableCell>
                      <TableCell>Açıklama</TableCell>
                      <TableCell>Tip</TableCell>
                      <TableCell>Kullanıcı Sayısı</TableCell>
                      <TableCell>Sayfa İzinleri</TableCell>
                      <TableCell>İşlem İzinleri</TableCell>
                      <TableCell>İşlemler</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {roles.map((role) => (
                      <TableRow key={role.id}>
                        <TableCell>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <GroupIcon />
                            {role.name}
                          </Box>
                        </TableCell>
                        <TableCell>{role.description}</TableCell>
                        <TableCell>
                          <Chip 
                            label={role.type} 
                            color={role.type === 'predefined' ? 'primary' : 'default'}
                            size="small" 
                          />
                        </TableCell>
                        <TableCell>
                          <Chip label={role.userCount || 0} size="small" />
                        </TableCell>
                        <TableCell>
                          <Chip 
                            label={`${role.pagePermissions?.length || 0} sayfa`} 
                            size="small" 
                            color="info"
                          />
                        </TableCell>
                        <TableCell>
                          <Chip 
                            label={`${role.operationPermissions?.length || 0} işlem`} 
                            size="small" 
                            color="secondary"
                          />
                        </TableCell>
                        <TableCell>
                          <IconButton onClick={() => handleEditRole(role)}>
                            <EditIcon />
                          </IconButton>
                          {role.type !== 'predefined' && (
                            <IconButton 
                              color="error" 
                              onClick={() => handleDeleteRole(role.id)}
                            >
                              <DeleteIcon />
                            </IconButton>
                          )}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          </Grid>
        </TabPanel>

        <TabPanel value={activeTab} index={1}>
          <Typography variant="h6" gutterBottom>
            Sayfa Bazlı İzinler
          </Typography>
          <Grid container spacing={2}>
            {predefinedPages.map((page) => (
              <Grid item xs={12} md={6} key={page.id}>
                <Card>
                  <CardContent>
                    <Typography variant="h6">{page.name}</Typography>
                    <Typography variant="body2" color="text.secondary" gutterBottom>
                      {page.description}
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      Modül: {page.module} | Yol: {page.path}
                    </Typography>
                    <Box sx={{ mt: 2 }}>
                      <Grid container spacing={1}>
                        <Grid item xs={6}>
                          <FormControlLabel
                            control={<Checkbox size="small" />}
                            label="Görüntüle"
                          />
                        </Grid>
                        <Grid item xs={6}>
                          <FormControlLabel
                            control={<Checkbox size="small" />}
                            label="Oluştur"
                          />
                        </Grid>
                        <Grid item xs={6}>
                          <FormControlLabel
                            control={<Checkbox size="small" />}
                            label="Düzenle"
                          />
                        </Grid>
                        <Grid item xs={6}>
                          <FormControlLabel
                            control={<Checkbox size="small" />}
                            label="Sil"
                          />
                        </Grid>
                        <Grid item xs={6}>
                          <FormControlLabel
                            control={<Checkbox size="small" />}
                            label="Dışa Aktar"
                          />
                        </Grid>
                        <Grid item xs={6}>
                          <FormControlLabel
                            control={<Checkbox size="small" />}
                            label="İçe Aktar"
                          />
                        </Grid>
                      </Grid>
                    </Box>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </TabPanel>

        <TabPanel value={activeTab} index={2}>
          <Typography variant="h6" gutterBottom>
            İşlem Bazlı İzinler
          </Typography>
          <Grid container spacing={2}>
            {predefinedOperations.map((operation) => (
              <Grid item xs={12} md={6} key={operation.id}>
                <Card>
                  <CardContent>
                    <Typography variant="h6">{operation.name}</Typography>
                    <Typography variant="body2" color="text.secondary" gutterBottom>
                      {operation.description}
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      Kod: {operation.code} | Modül: {operation.module}
                    </Typography>
                    <Box sx={{ mt: 2 }}>
                      <FormControlLabel
                        control={<Checkbox size="small" />}
                        label="İşlemi Yapabilir"
                      />
                      <Grid container spacing={1} sx={{ mt: 1 }}>
                        <Grid item xs={6}>
                          <TextField
                            size="small"
                            label="Maks. Tutar"
                            type="number"
                            fullWidth
                          />
                        </Grid>
                        <Grid item xs={6}>
                          <TextField
                            size="small"
                            label="Min. Tutar"
                            type="number"
                            fullWidth
                          />
                        </Grid>
                      </Grid>
                    </Box>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </TabPanel>

        <TabPanel value={activeTab} index={3}>
          <Typography variant="h6" gutterBottom>
            İskonto İzinleri
          </Typography>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Kullanıcı</TableCell>
                  <TableCell>Maks. Oran (%)</TableCell>
                  <TableCell>Maks. Tutar</TableCell>
                  <TableCell>Kategori Kısıtlaması</TableCell>
                  <TableCell>Marka Kısıtlaması</TableCell>
                  <TableCell>Onay Gerekli</TableCell>
                  <TableCell>Durum</TableCell>
                  <TableCell>İşlemler</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {discountPermissions.map((permission) => (
                  <TableRow key={permission.userId}>
                    <TableCell>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <PersonIcon />
                        {permission.userName}
                      </Box>
                    </TableCell>
                    <TableCell>
                      <Chip label={`%${permission.maxDiscountRate}`} color="primary" />
                    </TableCell>
                    <TableCell>
                      <Chip label={`₺${permission.maxDiscountAmount}`} color="secondary" />
                    </TableCell>
                    <TableCell>
                      {permission.categoryRestrictions?.length > 0 ? (
                        <Chip label={`${permission.categoryRestrictions.length} kategori`} size="small" />
                      ) : (
                        <Chip label="Yok" size="small" color="default" />
                      )}
                    </TableCell>
                    <TableCell>
                      {permission.brandRestrictions?.length > 0 ? (
                        <Chip label={`${permission.brandRestrictions.length} marka`} size="small" />
                      ) : (
                        <Chip label="Yok" size="small" color="default" />
                      )}
                    </TableCell>
                    <TableCell>
                      {permission.requiresApproval ? (
                        <CheckCircleIcon color="warning" />
                      ) : (
                        <CheckCircleIcon color="success" />
                      )}
                    </TableCell>
                    <TableCell>
                      <Chip label="Aktif" color="success" size="small" />
                    </TableCell>
                    <TableCell>
                      <IconButton>
                        <EditIcon />
                      </IconButton>
                      <IconButton color="error">
                        <DeleteIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </TabPanel>

        <TabPanel value={activeTab} index={4}>
          <Typography variant="h6" gutterBottom>
            Kullanıcı Yetki Özeti
          </Typography>
          <Grid container spacing={2}>
            {users.map((user) => (
              <Grid item xs={12} md={6} key={user.id}>
                <Card>
                  <CardContent>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
                      <PersonIcon />
                      <Typography variant="h6">{user.name}</Typography>
                      <Chip label={user.role} size="small" color="primary" />
                    </Box>
                    <Typography variant="body2" color="text.secondary" gutterBottom>
                      {user.email}
                    </Typography>
                    
                    <Divider sx={{ my: 1 }} />
                    
                    <Typography variant="subtitle2" gutterBottom>
                      Sayfa İzinleri
                    </Typography>
                    <Box sx={{ mb: 2 }}>
                      {user.pagePermissions?.slice(0, 3).map((perm) => (
                        <Chip key={perm} label={perm} size="small" sx={{ mr: 0.5, mb: 0.5 }} />
                      ))}
                      {user.pagePermissions?.length > 3 && (
                        <Chip label={`+${user.pagePermissions.length - 3} daha`} size="small" />
                      )}
                    </Box>
                    
                    <Typography variant="subtitle2" gutterBottom>
                      İşlem İzinleri
                    </Typography>
                    <Box sx={{ mb: 2 }}>
                      {user.operationPermissions?.slice(0, 3).map((perm) => (
                        <Chip key={perm} label={perm} size="small" color="secondary" sx={{ mr: 0.5, mb: 0.5 }} />
                      ))}
                      {user.operationPermissions?.length > 3 && (
                        <Chip label={`+${user.operationPermissions.length - 3} daha`} size="small" color="secondary" />
                      )}
                    </Box>
                    
                    {user.discountPermission && (
                      <>
                        <Typography variant="subtitle2" gutterBottom>
                          İskonto İzni
                        </Typography>
                        <Box>
                          <Chip 
                            label={`%${user.discountPermission.maxDiscountRate} / ₺${user.discountPermission.maxDiscountAmount}`} 
                            size="small" 
                            color="info"
                          />
                        </Box>
                      </>
                    )}
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </TabPanel>
      </Paper>

      {/* Add/Edit Role Dialog */}
      <Dialog open={openDialog} onClose={() => setOpenDialog(false)} maxWidth="lg" fullWidth>
        <DialogTitle>
          {selectedRole ? 'Rol Düzenle' : 'Yeni Rol Ekle'}
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={3} sx={{ mt: 1 }}>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Rol Adı"
                value={formData.name || ''}
                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <FormControl fullWidth>
                <InputLabel>Rol Tipi</InputLabel>
                <Select
                  value={formData.type || 'custom'}
                  onChange={(e) => setFormData({ ...formData, type: e.target.value })}
                >
                  <MenuItem value="predefined">Önceden Tanımlı</MenuItem>
                  <MenuItem value="custom">Özel</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Açıklama"
                multiline
                rows={2}
                value={formData.description || ''}
                onChange={(e) => setFormData({ ...formData, description: e.target.value })}
              />
            </Grid>
            
            <Grid item xs={12}>
              <Typography variant="h6" gutterBottom>
                Sayfa İzinleri
              </Typography>
              <Grid container spacing={2}>
                {predefinedPages.map((page) => (
                  <Grid item xs={12} md={6} key={page.id}>
                    <Card variant="outlined">
                      <CardContent>
                        <Typography variant="subtitle1">{page.name}</Typography>
                        <Typography variant="body2" color="text.secondary" gutterBottom>
                          {page.description}
                        </Typography>
                        <Grid container spacing={1}>
                          <Grid item xs={6}>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  size="small"
                                  checked={formData.pagePermissions?.find(p => p.pagePermissionId === page.id)?.canView || false}
                                  onChange={(e) => handlePagePermissionChange(page.id, 'canView', e.target.checked)}
                                />
                              }
                              label="Görüntüle"
                            />
                          </Grid>
                          <Grid item xs={6}>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  size="small"
                                  checked={formData.pagePermissions?.find(p => p.pagePermissionId === page.id)?.canCreate || false}
                                  onChange={(e) => handlePagePermissionChange(page.id, 'canCreate', e.target.checked)}
                                />
                              }
                              label="Oluştur"
                            />
                          </Grid>
                          <Grid item xs={6}>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  size="small"
                                  checked={formData.pagePermissions?.find(p => p.pagePermissionId === page.id)?.canEdit || false}
                                  onChange={(e) => handlePagePermissionChange(page.id, 'canEdit', e.target.checked)}
                                />
                              }
                              label="Düzenle"
                            />
                          </Grid>
                          <Grid item xs={6}>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  size="small"
                                  checked={formData.pagePermissions?.find(p => p.pagePermissionId === page.id)?.canDelete || false}
                                  onChange={(e) => handlePagePermissionChange(page.id, 'canDelete', e.target.checked)}
                                />
                              }
                              label="Sil"
                            />
                          </Grid>
                        </Grid>
                      </CardContent>
                    </Card>
                  </Grid>
                ))}
              </Grid>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDialog(false)}>İptal</Button>
          <Button onClick={handleSaveRole} variant="contained">Kaydet</Button>
        </DialogActions>
      </Dialog>

      {/* Add/Edit Discount Permission Dialog */}
      <Dialog open={openDiscountDialog} onClose={() => setOpenDiscountDialog(false)} maxWidth="md" fullWidth>
        <DialogTitle>
          {selectedUser ? 'İskonto İzni Düzenle' : 'Yeni İskonto İzni'}
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid item xs={12} md={6}>
              <FormControl fullWidth>
                <InputLabel>Kullanıcı</InputLabel>
                <Select
                  value={discountFormData.userId || ''}
                  onChange={(e) => setDiscountFormData({ ...discountFormData, userId: e.target.value })}
                >
                  {users.map((user) => (
                    <MenuItem key={user.id} value={user.id}>{user.name}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Maksimum İskonto Oranı (%)"
                type="number"
                value={discountFormData.maxDiscountRate || ''}
                onChange={(e) => setDiscountFormData({ ...discountFormData, maxDiscountRate: parseFloat(e.target.value) })}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Maksimum İskonto Tutarı (₺)"
                type="number"
                value={discountFormData.maxDiscountAmount || ''}
                onChange={(e) => setDiscountFormData({ ...discountFormData, maxDiscountAmount: parseFloat(e.target.value) })}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <FormControlLabel
                control={
                  <Switch
                    checked={discountFormData.requiresApproval || false}
                    onChange={(e) => setDiscountFormData({ ...discountFormData, requiresApproval: e.target.checked })}
                  />
                }
                label="Onay Gerekli"
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Kategori Kısıtlamaları (virgülle ayırın)"
                value={discountFormData.categoryRestrictions?.join(', ') || ''}
                onChange={(e) => setDiscountFormData({ 
                  ...discountFormData, 
                  categoryRestrictions: e.target.value.split(',').map(s => s.trim()).filter(s => s)
                })}
                helperText="Örnek: Motor Yağları, Fren Sistemleri"
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Marka Kısıtlamaları (virgülle ayırın)"
                value={discountFormData.brandRestrictions?.join(', ') || ''}
                onChange={(e) => setDiscountFormData({ 
                  ...discountFormData, 
                  brandRestrictions: e.target.value.split(',').map(s => s.trim()).filter(s => s)
                })}
                helperText="Örnek: Castrol, Brembo"
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDiscountDialog(false)}>İptal</Button>
          <Button onClick={handleSaveDiscountPermission} variant="contained">Kaydet</Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
      >
        <Alert 
          onClose={() => setSnackbar({ ...snackbar, open: false })} 
          severity={snackbar.severity}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default UserPermissions;
